import clsx from 'clsx';
import { ChangeEvent, InputHTMLAttributes, memo, PropsWithChildren } from 'react';
import { CheckIcon } from 'src/modules/common/icons/CheckIcon';

type Props = PropsWithChildren<{
    id: string;
    checked: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}>

export type CheckboxButtonProps = Props & Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'id' | 'checked'>;

export const CheckboxButton = memo((
    {
        onChange,
        disabled,
        value,
        id,
        checked,
        name,
        required,
        children,
        ...rest
    }: CheckboxButtonProps,
) => (
    <div className="vss-checkbox">
        <input
            {...rest}
            type="checkbox"
            className="vss-checkbox__input"
            onChange={onChange}
            id={id}
            disabled={disabled}
            value={value}
            name={name}
            required={required}
            checked={checked}
        />

        <label
            htmlFor={id}
            className={clsx({
                'vss-checkbox__label': true,
                'vss-checkbox__label--disabled': disabled,
            })}
        >
            <span className={clsx({
                'vss-checkbox__appearance': true,
                'vss-checkbox__appearance--disabled': disabled,
                'vss-checkbox__appearance--checked': checked,
            })}
            >
                {checked && <CheckIcon/>}
            </span>

            {children && (
                <span className={clsx({
                    'vss-checkbox__label-text': true,
                    'vss-checkbox__label-text--disabled': disabled,
                    'vss-checkbox__label-text--checked': checked,
                })}
                >
                    {children}
                </span>
            )}
        </label>
    </div>
));
